// src/services/publicService.ts
// Service pour les appels API publics (sans authentification)
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1';

// Instance axios sans intercepteur d'authentification
const publicApi = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export interface PublicUser {
    id: number;
    name: string;
    profile_picture?: string;
}

export interface PublicMedia {
    id: number;
    file_url: string;
    thumbnail_url?: string;
    file_type: 'image' | 'video' | 'audio';
    caption?: string;
    alt_text?: string;
}

export interface PublicPost {
    id: number;
    ethiopian_month: number;
    ethiopian_day: number;
    ethiopian_year?: number;
    title?: string;
    content: string;
    post_type: string;
    visibility: string;
    media: PublicMedia[];
    user: PublicUser;
    author_name?: string;
    reactions_count: number;
    comments_count: number;
    shares_count: number;
    created_at: string;
    updated_at: string;
}

export interface PublicComment {
    id: number;
    content: string;
    user: PublicUser;
    reactions_count: number;
    replies_count: number;
    created_at: string;
    replies?: PublicComment[];
}

/**
 * Récupérer un post par son ID (public, sans auth)
 */
export const getPublicPostById = async (postId: number): Promise<PublicPost> => {
    const response = await publicApi.get(`/public/posts/${postId}`);
    return response.data;
};

/**
 * Récupérer les commentaires d'un post (public, sans auth)
 */
export const getPublicPostComments = async (
    postId: number,
    skip: number = 0,
    limit: number = 50
): Promise<PublicComment[]> => {
    const response = await publicApi.get(`/public/posts/${postId}/comments`, {
        params: { skip, limit }
    });
    return response.data || [];
};

export default {
    getPublicPostById,
    getPublicPostComments,
};
